import api from './client';
import type { DimensaoTipo } from '../types/metaCompraDimensao';
import type {
  CriarMetaCompraDimensaoLoteRequest,
  CriarMetaCompraDimensaoLoteResponse,
  CriarMetaCompraDimensaoLoteResponseData,
  MetaCompraDimensaoLoteResponse,
  MetaCompraDimensaoLoteResponseData,
} from '../types/metaCompraDimensaoLote';

export interface BuscarLoteFiltros {
  anoMes: string;
  empresas: string[];
  dimensao: DimensaoTipo;
  limit?: number;
}

export const metaCompraDimensaoLoteApi = {
  buscar: async (filtros: BuscarLoteFiltros): Promise<MetaCompraDimensaoLoteResponseData> => {
    const params = new URLSearchParams();
    params.set('anoMes', filtros.anoMes);
    params.set('dimensao', filtros.dimensao);
    if (filtros.limit) params.set('limit', String(filtros.limit));
    filtros.empresas.forEach((e) => params.append('empresa', e));
    const resp = await api.get<MetaCompraDimensaoLoteResponse>(
      `/compras/metas/dimensao/lote?${params.toString()}`,
    );
    return resp.data.data;
  },

  criar: async (req: CriarMetaCompraDimensaoLoteRequest): Promise<CriarMetaCompraDimensaoLoteResponseData> => {
    const resp = await api.post<CriarMetaCompraDimensaoLoteResponse>(
      '/compras/metas/dimensao/lote',
      req,
    );
    return resp.data.data;
  },
};
